var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgService = function SvgService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "service_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FB5FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E88EB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#service_svg__a)",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.903 7c4.776 0 8.684 3.533 8.895 7.951a.558.558 0 0 1 .01.1v4.62a.615.615 0 0 1-.048.238c-.143.924-.611 1.721-1.399 2.376-1.638 1.361-4.216 1.73-5.653 1.774l-.356.006c-.257.569-.824.934-1.449.935-.877 0-1.59-.713-1.59-1.59a1.592 1.592 0 0 1 3.064-.597l.258-.005c1.173-.038 3.547-.345 4.923-1.489.367-.304.63-.643.793-1.02h-.577a2.305 2.305 0 0 1-2.302-2.303v-1.27a2.305 2.305 0 0 1 2.302-2.302h.715c-.48-3.474-3.7-6.168-7.586-6.168-3.741 0-6.863 2.496-7.52 5.782h.65a2.305 2.305 0 0 1 2.302 2.303v1.27a2.305 2.305 0 0 1-2.303 2.303H7.63A.628.628 0 0 1 7 19.286v-4.62a.62.62 0 0 1 .053-.251C7.539 10.252 11.323 7 15.903 7Zm0 16.075a.335.335 0 1 0 .001 0Zm7.649-7.395h-.778c-.577 0-1.046.47-1.046 1.046v1.27c0 .578.469 1.047 1.046 1.047h.778V15.68Zm-14.52-.385h-.777v3.363h.777c.577 0 1.047-.47 1.047-1.047v-1.27c0-.577-.47-1.046-1.047-1.046Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

export default SvgService;